import { createUseToast } from '@dozuki/web-js/components';
import { useToast as useChakraToast } from '@chakra-ui/react';

export const useToast = createUseToast(useChakraToast);
